import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/system';

const SearchBarWrapper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '20px',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  marginRight: '1rem',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginRight: '0',
  },
}));

const InputBaseStyled = styled(InputBase)({
  marginLeft: '1rem',
  flex: 1,
  '& input': {
    padding: '0.5rem',
  },
});

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (searchTerm) {
      navigate(`/search/${searchTerm}`);

      setSearchTerm('');
    }
  };

  return (
    <SearchBarWrapper component="form" onSubmit={handleSubmit}>
      <InputBaseStyled
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <IconButton type="submit" sx={{ p: '10px', color: 'red' }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </SearchBarWrapper>
  );
};

export default SearchBar;
